export default __webpack_public_path__ + "static/media/unknown.ded5854a.svg";